<app-header-one [sticky]="true"></app-header-one>

<div>
  <div class="overlay-content">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <form [formGroup]="searchForm">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="exampleInputPassword1"
                formControlName="termoPesquisa"
                placeholder="Pesquise seu Produto"
                style="border: none; border-bottom: 1px solid black"
              />
            </div>
            <div
              class="col-md-6"
              style="position: relative; top: -45px; left: 887px"
            >
              <div class="text-right">
                <button
                  style="
                    margin-right: 15px;
                    background-color: #714193;
                    border: none;
                  "
                  class="btn btn-primary"
                  type="button"
                  (click)="procurarItem()"
                >
                  <span class="fa fa-search"></span>
                  Pesquisar
                </button>
                <button
                  class="btn btn-secondary"
                  type="button"
                  (click)="limpar()"
                >
                  <span class="fa fa-eraser"> </span>
                  Limpar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="section-products">
  <div class="container">
    <div class="title1">
      <h3 class="title-inner1">RESULTADO DA BUSCA</h3>
    </div>

    <div class="row">
      <div class="col-md-6 col-lg-4 col-xl-3" *ngFor="let item of newItems">
        <div id="product-1" class="single-product">
          <div
            [routerLink]="['/shop/product/left/sidebar/', item.id]"
            class="part-1"
            style="background: url({{ item.imagemPrincipal }})
             no-repeat center;
        background-size: cover;
        transition: all 0s;"
          >
            <ul>
              <li *ngIf="item.situacao != 'Vitrine' && item.grade === 'Não'">
                <a
                  title="Adicionar ao Carrinho"
                  (click)="addToCart(item)"
                  style="cursor: pointer"
                >
                  <i class="ti-shopping-cart"></i
                ></a>
              </li>
              <li>
                <a
                  title="Ver Produto"
                  [routerLink]="['/shop/product/left/sidebar/', item.id]"
                  style="cursor: pointer"
                >
                  <i class="ti-search"></i
                ></a>
              </li>

              <li>
                <a
                  title="Adicioanr a Lista de Desejos"
                  (click)="addToWishlist(item)"
                  style="cursor: pointer"
                >
                  <i class="ti-heart"></i
                ></a>
              </li>
            </ul>
          </div>
          <div class="part-2">
            <h3 class="product-title">
              <strong> {{ item.title }} </strong>
            </h3>
            <h3 class="product-title">Código: {{ item.id }}</h3>
            <h4 class="product-price" *ngIf="item.precoOriginal >= 0">
              R$ {{ item.precoOriginal }}
            </h4>
            <h4 *ngIf="item.precoOriginal < 0">
              <span style="font-size: 17px">Preço sob consulta!</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap");

  body {
    font-family: "Poppins", sans-serif;
    color: #444444;
  }

  a,
  a:hover {
    text-decoration: none;
    color: inherit;
  }

  .section-products {
    padding: 10px 0 54px; /* padding: 10px 0 54px; */
  }

  .section-products .header {
    margin-bottom: 10px; /* margin-bottom: 50px; */
  }

  .section-products .header h3 {
    font-size: 1rem;
    color: #fe302f;
    font-weight: 500;
  }

  .section-products .header h2 {
    font-size: 2.2rem;
    font-weight: 400;
    color: #444444;
  }

  .section-products .single-product {
    margin-bottom: 26px;
  }

  .section-products .single-product .part-1 {
    position: relative;
    height: 370px;
    max-height: 370px;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .section-products .single-product .part-1::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    transition: all 0.3s;
  }

  .section-products .single-product:hover .part-1::before {
    transform: scale(1.2, 1.2) rotate(5deg);
  }

  /*
    .section-products #product-1 .part-1::before {
      background: url("https://i.ibb.co/L8Nrb7p/1.jpg") no-repeat center;
      background-size: cover;
      transition: all 0.3s;
    } */

  .section-products #product-2 .part-1::before {
    background: url("https://i.ibb.co/cLnZjnS/2.jpg") no-repeat center;
    background-size: cover;
  }

  .section-products #product-3 .part-1::before {
    background: url("https://i.ibb.co/L8Nrb7p/1.jpg") no-repeat center;
    background-size: cover;
  }

  .section-products #product-4 .part-1::before {
    background: url("https://i.ibb.co/cLnZjnS/2.jpg") no-repeat center;
    background-size: cover;
  }

  .section-products .single-product .part-1 .discount,
  .section-products .single-product .part-1 .new {
    position: absolute;
    top: 15px;
    left: 20px;
    color: #ffffff;
    background-color: #fe302f;
    padding: 2px 8px;
    text-transform: uppercase;
    font-size: 0.85rem;
  }

  .section-products .single-product .part-1 .new {
    left: 0;
    background-color: #444444;
  }

  .section-products .single-product .part-1 ul {
    position: absolute;
    bottom: -41px;
    left: 20px;
    margin: 0;
    padding: 0;
    list-style: none;
    opacity: 0;
    transition: bottom 0.5s, opacity 0.5s;
  }

  .section-products .single-product:hover .part-1 ul {
    bottom: 30px;
    opacity: 1;
  }

  .section-products .single-product .part-1 ul li {
    display: inline-block;
    margin-right: 4px;
  }

  .section-products .single-product .part-1 ul li a {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    color: #444444;
    text-align: center;
    box-shadow: 0 2px 20px rgb(50 50 50 / 10%);
    transition: color 0.2s;
  }

  .section-products .single-product .part-1 ul li a:hover {
    color: #fe302f;
  }

  .section-products .single-product .part-2 .product-title {
    font-size: 1rem;
  }

  .section-products .single-product .part-2 h4 {
    display: inline-block;
    font-size: 1rem;
  }

  .section-products .single-product .part-2 .product-old-price {
    position: relative;
    padding: 0 7px;
    margin-right: 2px;
    opacity: 0.6;
  }

  .section-products .single-product .part-2 .product-old-price::after {
    position: absolute;
    content: "";
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #444444;
    transform: translateY(-50%);
  }
</style>
